import React from 'react';
import { Link } from 'react-router-dom';

import ProtectedData from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    reporter: string;
    className?: string;
}

const Reporter: React.FC<Props> = ({ reporter, className }) => {
    const { classes, cx } = useStyles();

    return (
        <span className={cx(classes.container, className)}>
            <span className={classes.secondary}>{'Reported by'}</span>
            &nbsp;
            <ProtectedData data={reporter}>
                {({ isProtected, content }) =>
                    isProtected ? (
                        <span className={classes.primary}>{content}</span>
                    ) : (
                        <Link to={`/search?query=reporter:"${content}"`} className={classes.primary} target="_blank">
                            {content}
                        </Link>
                    )
                }
            </ProtectedData>
        </span>
    );
};

export default Reporter;
